import React, { FunctionComponent } from 'react';
import { Page } from '../../components/Page';

export const Settings: FunctionComponent = () => {
  return <Page title="Settings" />;
};
